import * as React from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import styled from "styled-components";
import { wrap, increment, decrement, input } from "./numeric-input.module.css";

const Button = styled.button`
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Input = styled.input`
  border-style: none !important;
  text-align: center;
  font-family: "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  @media only screen and (max-width: 640px) {
    width: 22px;
  }
`;

export function NumericInput({
  onIncrement,
  onDecrement,
  className,
  disabled,
  ...props
}) {
  return (
    <div className={wrap}>
      <Button
        disabled={disabled}
        className={decrement}
        aria-label="Decrement"
        style={{ height: "15px", display: "flex", alignItems: "center" }}
        onClick={onDecrement}
      >
        <span>-</span>
        <AiOutlineMinus size={13} />
      </Button>
      <Input
        disabled={disabled}
        type="numeric"
        className={[input, className].join(" ")}
        style={{}}
        {...props}
      />
      <Button
        disabled={disabled}
        className={increment}
        aria-label="Increment"
        style={{ height: "15px", display: "flex", alignItems: "center" }}
        onClick={onIncrement}
      >
        <span>+</span>
        <AiOutlinePlus size={13} />
      </Button>
    </div>
  );
}
